import { render, staticRenderFns } from "./TFFAQ.vue?vue&type=template&id=1013b5dc&scoped=true&"
import script from "./TFFAQ.vue?vue&type=script&lang=js&"
export * from "./TFFAQ.vue?vue&type=script&lang=js&"
import style0 from "./TFFAQ.vue?vue&type=style&index=0&id=1013b5dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013b5dc",
  null
  
)

export default component.exports